import { DepartmentEnum, F5ApplicationParameters, TheatreEnum } from '@platform/client/schemas';
import { FormsInputDropdown } from '@platform/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageProps } from '../../Application';
import { useApplicationLocalStorage } from '../../application-hook';
import { ApplicationBackground } from '../../ApplicationBackground';
import { ApplicationPageContent } from '../../components/ApplicationPageContent';
import BackgroundImage from '../../images/Screen4F5.svg';

type FormValues = {
  theatre: string;
  department: string;
};

const THEATRE_OPTIONS = [
  { text: 'APCJ', textValue: TheatreEnum['APCJ'] },
  { text: 'EMEA', textValue: TheatreEnum['EMEA'] },
  { text: 'India', textValue: TheatreEnum['INDIA'] },
  { text: 'LATAM', textValue: TheatreEnum['LATAM'] },
  { text: 'North America', textValue: TheatreEnum['NORTH_AMERICA'] },
];

const DEPARTMENT_OPTIONS = [
  { text: 'Finance', textValue: DepartmentEnum.finance },
  {
    text: 'Global Services, Corporate Development, COO Office',
    textValue: DepartmentEnum['global-services'],
  },
  { text: 'Legal', textValue: DepartmentEnum['legal'] },
  { text: 'People & Culture', textValue: DepartmentEnum['people-culture'] },
  { text: 'Product & OCTO', textValue: DepartmentEnum['product'] },
  { text: 'Sales & WW Marketing', textValue: DepartmentEnum['sales'] },
  {
    text: 'Product Marketing & Technology Alliances',
    textValue: DepartmentEnum['product-marketing'],
  },
];

export const F5WorkExperience = (props: ApplicationPageProps) => {
  const { onBack, onContinue, progress } = { ...props };

  const { updateApplicationData, getApplicationDataByKey } =
    useApplicationLocalStorage<F5ApplicationParameters>();

  const {
    handleSubmit,
    formState: { errors },
    watch,
    control,
  } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      theatre: getApplicationDataByKey('theatre'),
      department: getApplicationDataByKey('department'),
    },
  });

  const submit: SubmitHandler<FormValues> = (data) => {
    updateApplicationData({
      theatre: data.theatre as TheatreEnum,
      department: data.department as DepartmentEnum,
    });
    onContinue();
  };

  const handleBack = () => {
    updateApplicationData({
      theatre: watch('theatre') as TheatreEnum,
      department: watch('department') as DepartmentEnum,
    });
    onBack();
  };

  return (
    <ApplicationBackground
      progress={progress}
      onBack={handleBack}
      onSubmit={handleSubmit(submit)}
      backgroundImage={BackgroundImage}
    >
      <ApplicationPageContent
        title='Tell us about your work at F5'
        description="This won't be on your profile, just a quick check-in on where you're working within F5."
      >
        <FormsInputDropdown
          control={control}
          rules={{ required: 'Select your theatre to continue' }}
          name='theatre'
          label='What theatre are you located in?'
          placeholder='Select one'
          items={THEATRE_OPTIONS}
          type='default'
          error={errors.theatre}
          inputDisabled={true}
        />
        <FormsInputDropdown
          control={control}
          rules={{ required: 'Select your department to continue' }}
          name='department'
          label='Which department are you in?'
          placeholder='Select one'
          items={DEPARTMENT_OPTIONS}
          type='default'
          error={errors.department}
          inputDisabled={true}
        />
      </ApplicationPageContent>
    </ApplicationBackground>
  );
};
